// Default feature flag values
export const DEFAULT_FEATURE_FLAGS = {
  // AI Analysis Features
  ANALYZE_PRODUCT_ENABLED: { value: false, state: 'disabled' },
  AUTO_AI_PROCESSING_ENABLED: { value: false, state: 'disabled' },
  
  // Background Removal Features
  BACKGROUND_REMOVAL_ENABLED: { value: true, state: 'on' },
  
  // Digital Try-On Features
  DIGITAL_TRY_ON_ENABLED: { value: true, state: 'on' },
  
  // Video Generation Features (Phase 2)
  VIDEO_GENERATION_ENABLED: { value: false, state: 'disabled' },
  
  // Advanced Features
  BULK_OPERATIONS_ENABLED: { value: true, state: 'on' },
  EXPORT_FEATURES_ENABLED: { value: true, state: 'on' },
  INVENTORY_EXPORT_ENABLED: { value: true, state: 'on' },
  
  // UI/UX Features
  ENHANCED_IMAGE_UPLOAD: { value: true, state: 'on' },
  DRAG_AND_DROP_REORDERING: { value: true, state: 'on' },
  
  // Marketplace Features
  MULTI_MARKETPLACE_LISTING: { value: true, state: 'on' },
  AUTOMATED_LISTING_PUBLISH: { value: true, state: 'on' },
};

// Feature flag descriptions for admin interface
export const FEATURE_FLAG_DESCRIPTIONS = {
  ANALYZE_PRODUCT_ENABLED: {
    title: "AI Product Analysis",
    description: "Enable AI-powered product analysis that automatically fills product details from images",
    category: "AI Features"
  },
  AUTO_AI_PROCESSING_ENABLED: {
    title: "Automatic AI Processing",
    description: "Automatically trigger AI workflow (background removal, try-on, video) when creating inventory items",
    category: "AI Features"
  },
  BACKGROUND_REMOVAL_ENABLED: {
    title: "Background Removal",
    description: "Enable automatic background removal for product images",
    category: "AI Features"
  },
  DIGITAL_TRY_ON_ENABLED: {
    title: "Digital Try-On",
    description: "Enable virtual try-on generation for clothing items",
    category: "AI Features"
  },
  VIDEO_GENERATION_ENABLED: {
    title: "Video Generation",
    description: "Enable automatic product video generation (Phase 2) - Coming Soon",
    category: "AI Features"
  },
  BULK_OPERATIONS_ENABLED: {
    title: "Bulk Operations",
    description: "Enable bulk operations for inventory management",
    category: "Management Features"
  },
  EXPORT_FEATURES_ENABLED: {
    title: "Export Features",
    description: "Enable inventory export functionality",
    category: "Management Features"
  },
  INVENTORY_EXPORT_ENABLED: {
    title: "Inventory Export Button",
    description: "Show the export button on the inventory page",
    category: "Management Features"
  },
  ENHANCED_IMAGE_UPLOAD: {
    title: "Enhanced Image Upload",
    description: "Enable enhanced image upload with preview and editing",
    category: "UI/UX Features"
  },
  DRAG_AND_DROP_REORDERING: {
    title: "Drag & Drop Reordering",
    description: "Enable drag and drop reordering for images",
    category: "UI/UX Features"
  },
  MULTI_MARKETPLACE_LISTING: {
    title: "Multi-Marketplace Listing",
    description: "Enable listing creation across multiple marketplaces",
    category: "Marketplace Features"
  },
  AUTOMATED_LISTING_PUBLISH: {
    title: "Automated Listing Publish",
    description: "Enable automated publishing of listings to marketplaces",
    category: "Marketplace Features"
  }
};